import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ErrorManagerService {
    errorChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor() { }

    setError(popupObj: any) {
        this.errorChange.next(popupObj);
    }
}
